import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import {
  Route,
  Switch,
  BrowserRouter as Router,
  Redirect,
} from 'react-router-dom';
import './index.css';

import Login from './pages/Login';
import PwSearch from './pages/PwSearch';
import PwReset from './pages/PwReset';
import MyPage from './pages/MyPage';
import SignUp from './pages/Signup/SignUp';
import AuthContext from './contexts/AuthContext';
import Err404 from './pages/Error/Err404';
import { ShopModeContextProvider } from './contexts/ShopModeContext';

function App() {
  const token =
    window.localStorage.getItem('token') ??
    window.sessionStorage.getItem('token');
  const [auth, setAuth] = React.useState(token);

  const query = window.location.search;
  const params = new URLSearchParams(query);

  if (
    params.get('mall_id') ||
    params.get('user_name') ||
    params.get('shop_no')
  ) {
    window.localStorage.setItem('mallId', params.get('mall_id'));
    window.sessionStorage.setItem('userName', params.get('user_name'));
    window.localStorage.setItem('shopNo', params.get('shop_no'));
  }
  return (
    <AuthContext.Provider value={{ auth: auth, setAuth }}>
      <Router>
        {auth ? (
          <ShopModeContextProvider auth={auth}>
            <Switch>
              <Route
                exact
                path="/"
                component={() => <Redirect to="/mypage/setting" />}
              />
              <Route path="/mypage" component={MyPage} />
              <Route component={Err404} />
            </Switch>
          </ShopModeContextProvider>
        ) : (
          <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/login" component={Login} />
            <Route path="/signup" component={SignUp} />
            <Route path="/pw-search" component={PwSearch} />
            <Route path="/pw-reset/:token" component={PwReset} />
            <Route component={Err404} />
          </Switch>
        )}
      </Router>
    </AuthContext.Provider>
  );
}

ReactDOM.render(<App />, document.getElementById('root'));
